import { render, staticRenderFns } from "./FilterButtonSeo.vue?vue&type=template&id=36bcff0d"
import script from "./FilterButtonSeo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterButtonSeo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports